module.exports = __webpack_public_path__ + "static/media/percentGrey.b55fe516.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Home/img/percentGrey.svg
// module id = 216
// module chunks = 8